"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GetBucketVersioningInput_1 = require("./GetBucketVersioningInput");
var GetBucketVersioningOutput_1 = require("./GetBucketVersioningOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.GetBucketVersioning = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "GetBucketVersioning",
    http: {
        method: "GET",
        requestUri: "/{Bucket}?versioning"
    },
    input: {
        shape: GetBucketVersioningInput_1.GetBucketVersioningInput
    },
    output: {
        shape: GetBucketVersioningOutput_1.GetBucketVersioningOutput
    },
    errors: []
};
//# sourceMappingURL=GetBucketVersioning.js.map